import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-promocion',
  templateUrl: './promocion.component.html',
  styleUrls: ['./promocion.component.css']
})
export class PromocionComponent implements OnInit {
  dataActual: any = null;

  infoPromo: any = {
    // promoguiasweb: {
    //   titulo: "TUFESAPACK 2025 - Promoción exclusiva para clientes nuevos",
    //   descripcion: `¡Llegó la PROMO 2025 con TUFESAPACK!\n
    //   ¿Listo para ahorrar y enviar más? Aprovecha nuestra promoción exclusiva para clientes nuevos:\n
    //   ●	1,000 guías web a $80 c/u (más IVA)
	  //   ●	500 guías web a $100 c/u (más IVA)
    //   `,
    //   beneficios: [
    //     "Hasta 20 kg por guía",
    //     "Recolección y entrega a domicilio",
    //     "Aplica solo en sucursales con servicio",
    //     "Promoción válida en toda la cobertura de sucursales TUFESAPACK."
    //   ],
    //   terminos: [
    //     "Aplica exclusivamente para clientes nuevos con primer consumo de contrato.",
    //     "Vigencia: del 14 al 18 de noviembre 2025.",
    //     "Precios más IVA.",
    //     "No aplica con otras promociones.",
    //     "Sujeto a cobertura TUFESAPACK.",
    //     "Máximo 20 kg por guía.",
    //     "Recolección y entrega disponible únicamente en sucursales con servicio activo.",
    //     "No transferible."
    //   ],
    //   imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_guiasWeb.webp",
    //   boton:"Comprar"
    // },
    promohermosillo: {
      titulo: "Promoción Hermosillo",
      descripcion: `Hermosillo manda más, ¡y paga por menos!\n
    Aprovecha esta súper promo en Hermosillo:\n
    Solo $25 pesos la recolección y 25% de descuento en tu envío a cualquier destino dentro de la cobertura TUFESA (aplicable en conjunto con recolección).\n
    Pide tu recolección, paga en sucursal o al recoger y deja que nosotros hagamos el resto. ¡Es el momento ideal para mandar todo lo que quieras!`,
      beneficios: [],
      terminos: [
        "Promoción válida únicamente para envíos recolectados con origen en Hermosillo.",
        "Recolección con costo de $25.00 pesos + 25% de descuento en el envío solo si es en conjunto con recolección.",
        "Aplica solo en pagos realizados con efectivo, tarjeta de débito o crédito.",
        "El servicio a domicilio (entrega final) se paga por separado.",
        "El empaque y embalaje tienen costo adicional.",
        "Promoción válida del 7 de abril al 31 de julio de 2025.",
        "No acumulable con otras promociones o descuentos."
      ],
      imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_hermosillo.webp"
    },
  //   promoguiasweb: {
  //     titulo: "Promoción Navojoa",
  //     descripcion:  `¡Que Navojoa mande con descuento!\n
  //     ¿Tienes paquetes que enviar desde Navojoa? ¡Ahora es el mejor momento! Con nuestra Promoción Navojoa, aprovecha descuentos especiales en tus envíos a Ciudad Obregón, Empalme, Guaymas y Hermosillo.\n
  //     Aprovecha esta promo especial al pagar en sucursal, con efectivo o tarjeta. ¡Haz que tus paquetes viajen más lejos por menos!`,
  //     beneficios: [
  //       "De 0 a 10 kg: 20% de descuento",
  //       "De 10.1 a 20 kg: 30% de descuento",
  //       "De 20.1 a 40 kg: 40% de descuento"
  //     ],
  //     terminos: [
  //       "Válido únicamente para envíos de paquetería con origen en Navojoa y destino a Ciudad Obregón, Empalme, Guaymas y Hermosillo.",
  //       "Promoción válida del 7 de abril de 2025 al 7 de julio de 2025.",
  //       "Aplica solo en pagos realizados en sucursal de origen, con efectivo o tarjeta de débito o crédito.",
  //       "El servicio a domicilio se cobra por separado.",
  //       "El empaque y embalaje tienen costo adicional.",
  //       "Esta promoción no es acumulable con otras promociones o descuentos."
  //     ],
  //  imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_navojoa.webp"
  //   },
  //   promomexicali: {
  //     titulo: "Promoción Mexicali",
  //     descripcion: `¡Mexicali manda en grande por solo $110.00 pesos!\n
  //   Si estás en Mexicali y tienes paquetes de 20 a 40 kilos, esta promoción es para ti:\n
  //   Envía tu paquetería a Tijuana o San Luis Río Colorado ¡por solo $110 pesos!\n\n
  //   Aplica en envíos pagados directamente en sucursal de origen.\n
  //   Puedes pagar con efectivo, tarjeta de débito o crédito.\n
  //   ¡Empaca, lleva tu envío y aprovecha esta promoción exclusiva!\n
  //   `,
  //     beneficios: [],
  //     terminos: [
  //       "Promoción válida únicamente para envíos de 20 a 40 kg, con origen en Mexicali y destino Tijuana o San Luis Río Colorado.",
  //       "El precio promocional de $110 pesos aplica solo en pagos realizados en sucursal.",
  //       "Válido para pagos con efectivo, tarjeta de débito o crédito.",
  //       "El servicio a domicilio (entrega final) se paga por separado.",
  //       "El empaque y embalaje tienen costo adicional.",
  //       "Vigencia: del 7 de abril al 7 de julio de 2025.",
  //       "Promoción no acumulable con otras ofertas o descuentos."
  //     ],
  //  imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_mexicali.webp"
  //   }
  };

  constructor(private route: ActivatedRoute, private router: Router, private metaService: Meta) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code && this.infoPromo[code]) {
        this.dataActual = this.infoPromo[code];
      } else {
        this.router.navigate(['/']); // Redirige al inicio si code es inválido o nulo
      }
    });

     this.metaService.updateTag({ name: 'robots', content: 'noindex' });
  }

}